module.exports = __webpack_public_path__ + "static/media/zvony3.9b0191b3.jpg";